const blockedEmailsList = [
    "yopmail",
    "temp-mail",
    "guerrillamail",
    "10minutemail",
    "mailinator",
    "mohmal",
    "maildrop",
    "disposable-email",
    "tempail",
    "emailondeck",
    "fakemailgenerator",
    "throwawaymail",
    "tempmail.ninja",
    "anonbox",
    "getnada",
    "crazymailing",
    "mail.ru",
    "tempr.email",
    "10minemail",
    "mailjetable",
    "internxt",
    "mail-Jetable",
    "spambox",
    "incognitomail",
    "jetable",
    "e4ward",
    "startMail",
    "expressletter",
    "trashmail",
    "temp-mail"
]

export default blockedEmailsList
